module.exports = __webpack_public_path__ + "static/media/nubemedio.fded64a8.svg";